module.exports = __webpack_public_path__ + "img/newsletter17.6e218509.png";